import { FlyoutTrackerStaticText } from '@com-delta-idp/mnx-capability-flyout-ui';
import {
  DashboardResponse,
  getAuxiliaryNavigation,
  HeaderFooterMachCore,
  MyFlightPanelAem,
  SalutationAem
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  MilesAvailableLabel,
  MyFlightLabel,
  SkyMilesMemberLabel,
  tier360MedallionLabel,
  TodayLabel
} from '../../models/constants/account-summary-header/account-summary-header.constants';
import { MY_FLIGHT_PANEL } from '../../models/constants/common/common.constants';

const getFlightPanel = (
  content: HeaderFooterMachCore
): MyFlightPanelAem | undefined =>
  getAuxiliaryNavigation(content, MY_FLIGHT_PANEL) as MyFlightPanelAem;

const getHourRange = (hour: number): number =>
  hour < 12 ? 0 : hour <= 17 ? 1 : 2;

const getFlightPanelField = <K extends keyof MyFlightPanelAem>(
  content: HeaderFooterMachCore,
  field: K,
  fallback: string
): string => (getFlightPanel(content)?.[field] as string) ?? fallback;

export const getWelcomeMessage = (
  staticContent: HeaderFooterMachCore,
  isDelta: boolean
): string => {
  const salutationText = getSalutationLabel(staticContent);
  if (!salutationText) return '';

  return isDelta
    ? salutationText[getHourRange(new Date().getHours())].salutationLabel
    : salutationText[3]?.salutationLabel ?? '';
};

export const getSalutationLabel = (
  content: HeaderFooterMachCore
): SalutationAem[] | undefined => getFlightPanel(content)?.salutation;

export const getMemberDescriptionMessage = (
  response: DashboardResponse,
  content: HeaderFooterMachCore
): string => {
  if (response.membershipLevel === 'FF') {
    return getFlightPanel(content)?.skymilesMember ?? SkyMilesMemberLabel;
  }
  return response.is360Tier
    ? getTier360MedallionMessage(content)
    : `${response.medallionMemberDesc}`;
};

export const getTier360MedallionMessage = (
  content: HeaderFooterMachCore
): string => {
  const medallionArray = getFlightPanel(content)?.medallion ?? [];
  return (
    medallionArray.find((el) => el.medallionId === 'DM360')?.medallionLabel ??
    tier360MedallionLabel
  );
};

export const isDelta = (content: HeaderFooterMachCore): boolean =>
  getFlightPanel(content)?.accountOverview === 'true';

export const getTrackerStaticText = (
  content: HeaderFooterMachCore
): FlyoutTrackerStaticText => {
  const { trackerStaticText } = content.header;
  return {
    ...trackerStaticText,
    availableMilesLabel: getFlightPanelField(
      content,
      'availableMilesLabel',
      MilesAvailableLabel
    ),
    todayLabel: getFlightPanelField(content, 'todayLabel', TodayLabel),
    myFlightLabel: getFlightPanelField(content, 'myFlightLabel', MyFlightLabel)
  };
};

export const getAvailableMilesText = (content: HeaderFooterMachCore): string =>
  getFlightPanelField(content, 'availableMilesLabel', MilesAvailableLabel);

export const getTodayLabel = (content: HeaderFooterMachCore): string =>
  getFlightPanelField(content, 'todayLabel', TodayLabel);

export const getMyFlightLabel = (content: HeaderFooterMachCore): string =>
  getFlightPanelField(content, 'myFlightLabel', MyFlightLabel);
